<template>
    <div id="nav_top_bar">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-auto d-md-none">
                    <router-link :to="{ name: 'HomeMenu' }">
                        <groomy-logo />
                    </router-link>
                </div>
                <div class="col">
                    <h1 class="mb-0">{{ $t('compte.welcome') }} {{ userDisplayName }}</h1>
                </div>
                <div class="col-auto">
                    <b-dropdown :text="$t('compte.mon_compte')" variant="link" right no-caret menu-class="nav-account-dropdown-menu">
                        <template #button-content>
                            <font-awesome-icon :icon="['fal', 'user-cog']" />
                            <span class="d-none d-md-inline ml-1">{{ $t('compte.mon_compte') }}</span>
                        </template>
                        <template v-if="userEmail">
                            <b-dropdown-text class="user-email-info">
                                <font-awesome-icon :icon="['fal', 'user']" class="mr-2" />
                                {{ userEmail }}
                            </b-dropdown-text>
                            <b-dropdown-divider />
                        </template>
                        <b-dropdown-item :to="{ name: 'resetPassword' }">
                            <font-awesome-icon :icon="['far', 'lock']" class="mr-2" />
                            {{ $t('compte.changer_mdp') }}
                        </b-dropdown-item>
                        <b-dropdown-item :to="{ name: 'switchLang' }">
                            <font-awesome-icon :icon="['far', 'globe']" class="mr-2" />
                            {{ $t('compte.changer_langue') }}
                        </b-dropdown-item>
                        <b-dropdown-divider />
                        <b-dropdown-item @click.prevent="logout">
                            <font-awesome-icon :icon="['fal', 'door-open']" class="mr-2" />
                            {{ $t('header.logout') }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from '@/mixins/Navigation.js'
import { EventBus } from 'EventBus'

export default {
    name: 'NavTopBar',
    mixins: [Navigation],
    data: () => ({
        userFirstname: null,
        userLastname: null,
        userRs: null,
        userEmail: null,
    }),
    computed: {
        /**
         * Retourne le nom complet de l'utilisateur en majuscules, ou sa raison sociale.
         * @returns {string}
         */
        userDisplayName() {
            const firstname = this.userFirstname
            const lastname = this.userLastname
            if (firstname || lastname) {
                const first = firstname ? firstname.toUpperCase() : ''
                const last = lastname ? lastname.toUpperCase() : ''
                return [first, last].filter(Boolean).join(' ')
            }
            return this.userRs
        }
    },
    mounted() {
        this.refreshUserName()
        EventBus.$on('UserMixin::initConfigLoaded', this.refreshUserName)
    },
    destroyed() {
        EventBus.$off('UserMixin::initConfigLoaded', this.refreshUserName)
    },
    methods: {
        refreshUserName() {
            this.userFirstname = this.getConfig('user_firstname')
            this.userLastname = this.getConfig('user_lastname')
            this.userRs = this.getConfig('user_rs')
            this.userEmail = this.getConfig('user_mail')
        },
        async logout() {
            await this.delogUser()
        }
    }
}
</script>
